export default __webpack_public_path__ + "static/media/icons-receptors.c2acd7b2.svg";